import { deletePlan } from './deletePlanThunk';
export default deletePlan;
